import React from "react";

const brochures = [
  {
    label: "Chicken Brochure",
    description: "Explore our premium marinated chicken products and offerings.",
    link: "/brochure/Zesty Tongue Chicken Brochure.pdf",
    color: "bg-orange-500 hover:bg-orange-600",
  },
  {
    label: "Fish & Prawns Brochure",
    description: "Discover our fresh and delicious fish & prawns selection.",
    link: "/brochure/Zesty Tongue Shrimps and Fish.pdf",
    color: "bg-blue-500 hover:bg-blue-600",
  },
  {
    label: "Fruit Pulp Brochure",
    description: "See our range of natural, high-quality fruit pulps.",
    link: "/brochure/Zesty Tongue Fruit Pulp Brochure.pdf",
    color: "bg-green-500 hover:bg-green-600",
  },
];

const BrochurePage = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-100 via-blue-50 to-green-100 py-16 px-4 pt-40">
    <h1 className="text-4xl font-bold mb-10 text-[#2c3e50]">Download Our Brochures</h1>
    <div className="flex flex-col md:flex-row gap-8 w-full max-w-5xl justify-center">
      {brochures.map((b, idx) => (
        <div
          key={idx}
          className="flex flex-col items-center bg-white rounded-2xl shadow-xl p-8 w-full md:w-80 border border-gray-100 hover:shadow-2xl transition-shadow duration-300"
        >
          <h2 className="text-2xl font-semibold mb-2 text-[#2c3e50]">{b.label}</h2>
          <p className="text-gray-600 mb-6 text-center">{b.description}</p>
          <a
            href={b.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`mt-auto px-6 py-3 rounded-lg shadow text-white text-lg font-semibold transition-colors duration-200 ${b.color}`}
          >
            Download
          </a>
        </div>
      ))}
    </div>
    <div className="mt-16 flex flex-col items-center">
      <a
        href="/"
        className="inline-block px-8 py-4 mt-4 rounded-xl bg-[#ff6b35] text-white text-xl font-bold shadow-lg hover:bg-[#ff884d] transition-colors duration-200"
      >
        Explore Zesty Tongue Website
      </a>
    </div>
  </div>
);

export default BrochurePage; 